import React from 'react'
import LeftmenuIn from '../Components/LeftmenuIn'
import DashnavIn from '../Components/DashnavIn'
import UpdateaccountComp from './UpdateaccountComp'

function Updateaccount() {
  return (
    <div className='mainContainer'>
        <LeftmenuIn/>
        <div className='theMainContainer'>
        <DashnavIn/>
        <UpdateaccountComp/>
        
        </div>
    </div> 
  )
}

export default Updateaccount